import { render, staticRenderFns } from "./DoctorEducationSection.vue?vue&type=template&id=f457ddd0"
import script from "./DoctorEducationSection.vue?vue&type=script&lang=js"
export * from "./DoctorEducationSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports